import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-awards-and-recognition',
  templateUrl: './awards-and-recognition.component.html',
  styleUrls: ['./awards-and-recognition.component.css']
})
export class AwardsAndRecognitionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
